export class Logger {
    constructor(opts = {}) {
        this.defaultOptions = {
            prefix: "[@devforce/trailhead-client-logger]: ",
        };
        this.options = this.defaultOptions;
        this.options = {
            ...this.defaultOptions,
            ...opts,
        };
    }
    info(msg, ...args) {
        console.info(`${this.options.prefix}${msg}`.trim(), ...args);
    }
    warn(msg, ...args) {
        console.warn(`${this.options.prefix}${msg}`.trim(), ...args);
    }
    error(msg, ...args) {
        var _a, _b;
        console.error(`${this.options.prefix}${msg}`.trim(), ...args);
        /* eslint-disable */
        // @ts-ignore
        if ((_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError) {
            // @ts-ignore
            const error = msg instanceof Error ? msg : new Error(msg);
            // @ts-ignore
            (_b = window.newrelic) === null || _b === void 0 ? void 0 : _b.noticeError(error);
        }
        /* eslint-enable */
    }
}
export const logger = new Logger();
